var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"post_share"},[_c('div',{staticClass:"inner"},[_c('h4',{staticClass:"h4_share"},[_vm._v("Share this article")]),_vm._v(" "),_c('ul',{staticClass:"social"},[(_vm.email)?_c('li',[_c('a',{staticClass:"share",attrs:{"href":'mailto:?subject=&' +
						_vm.title +
						'body=Check out this great article! ' +
						_vm.permalink +
						'.',"target":"_blank","title":_vm.title,"onclick":"window.open('mailto:?subject=' + encodeURIComponent(document.title) + '&body=Check out this great article! ' +  encodeURIComponent(document.URL)); return false;"}},[_c('img',{attrs:{"src":_vm.email_icon}})])]):_vm._e(),_vm._v(" "),(_vm.permalink)?_c('li',[_c('a',{staticClass:"share",attrs:{"href":'https://www.linkedin.com/shareArticle?mini=true&url=' +
						_vm.permalink +
						'&title=&summary=&source=',"target":"_blank"}},[_c('img',{attrs:{"src":_vm.linkedin_icon}})])]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/edc.stagingwebsite.dev/web/app/themes/edc/node_modules/vue-loader/lib?{}!./scripts/vue/PostShare.vue?vue&type=template&id=64d2b8a5&scoped=true&
// module id = 303
// module chunks = 0